import React, { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Column } from "primereact/column";
import EditAddForm from "./edit-add-form";
import Spinner from "../../components/spinner";
import { axiosApi } from "../../../services/axios_api";
import PaginatorComponent from "../../components/paginator";
import useDebounce from "../../components/hooks/useDebounce";
import { toast } from "react-toastify";
import editIcon from "../../../../assets/assests/edit.png";
import { Tag } from "primereact/tag";
import { exportToExcel, renderTextWithTooltip } from "../../components/helper";
import Dots from "../../../../assets/assests/detail.png";
import Details from "./details-kiosk";

export default function KioskManagement() {
  const [globalFilter, setGlobalFilter] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [res, setRes] = useState([]);
  const [rowselect, setRowselect] = useState(null);
  const [editable, setEditable] = useState();
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [showdetail, setShowdetail] = useState(false);

  const debouncedSearch = useDebounce(globalFilter, 500);

  const getKioskData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(`/Portal/kiosks/get-all-paginated`, {
        params: {
          pageNumber,
          pageSize,
          searchTerm: debouncedSearch || "",
        },
      });
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getKioskData(pageNumber, rows);
  };

  useEffect(() => {
    getKioskData();
  }, [debouncedSearch]);

  const onHide = () => {
    setShowDialog(false);
  };
  const showDetails = (rowData) => {
    setRowselect(rowData);
    setShowdetail(true);
  };
  const editAction = (rowData) => {
    setEditable(true);
    setRowselect(rowData);
    setShowDialog(true);
  };

  const actionTemplate = (rowData) => {
    return (
      <div className="action-buttons flex">
        <Button
          className=" p-button-edit p-0 mr-3"
          onClick={() => {
            toggleDialogMode(true);
            editAction(rowData);
          }}
          aria-label="Edit"
        >
          <img src={editIcon} alt="Edit" />
        </Button>
        <Button
          className="p-button-edit p-0 mr-3"
          onClick={() => showDetails(rowData)}
        >
          <img src={Dots} alt="Details" />
        </Button>
      </div>
    );
  };

  const toggleDialogMode = (editMode = false, rowData = null) => {
    setShowDialog(true);
    setIsEdit(editMode);
    setRowselect(rowData);
    if (!editMode) {
      setSelectedData(null);
    }
  };

  const columnsData = [
    {
      field: "id",
      header: "KIOSK ID",
      body: (rowData) => rowData.id || "--",
      frozen: true,
    },
    {
      field: "name",
      header: "KIOSK Name",
      body: (rowData) => renderTextWithTooltip(rowData, "name", "bottom"),
      frozen: true,
    },
    {
      field: "ipAddress",
      header: "IP Address",
      body: (rowData) => rowData.ipAddress || "--",
    },
    // {
    //   field: "location",
    //   header: "Location",
    //   body: (rowData) => rowData.location || "--",
    // },
    {
      field: "cardsAvailable",
      header: "Cash Available",
      body: (rowData) => rowData.cardsAvailable || "--",
    },
    // {
    //   field: "cardsCapacity",
    //   header: "Cards Capacity",
    //   body: (rowData) => rowData.cardsCapacity || "--",
    // },
    // {
    //   field: "cashAcceptorCapacity",
    //   header: "cash Acceptor Capacity",
    //   body: (rowData) => rowData.cashAcceptorCapacity || "--",
    // },
    // {
    //   field: "dailyTransactionLimit",
    //   header: "daily Transaction Limit",
    //   body: (rowData) => rowData.dailyTransactionLimit || "--",
    // },
    // {
    //   field: "receiptsPrinterStatus",
    //   header: "receipts Printer Status ",
    //   body: (rowData) => rowData.receiptsPrinterStatus || "--",
    // },
    // {
    //   field: "singleTransactionLimit",
    //   header: "single Transaction Limit",
    //   body: (rowData) => rowData.singleTransactionLimit || "--",
    // },
    {
      field: "softwareVersion",
      header: "software Version",
      body: (rowData) => rowData.softwareVersion || "--",
    },
    // {
    //   field: "LastActwarningLevelInputive",
    //   header: "warning Level Input",
    //   body: (rowData) => rowData.warningLevelInput || "--",
    // },
    {
      field: "connectivityStatus",
      header: "Connectivity Status",
      body: (rowData) => (
        <span
          style={{
            fontWeight: "600",
            color: rowData.connectivityStatus === "Online" ? "green" : "red",
          }}
        >
          {rowData.connectivityStatus ?? "--"}
        </span>
      ),
    },
    {
      field: "healthStatus",
      header: "Health Status",
      body: (rowData) => (
        <span
          style={{
            fontWeight: "600",
            color:
              rowData.healthStatus === "Good"
                ? "green"
                : rowData.healthStatus === "Warnings"
                ? "orange"
                : "red",
          }}
        >
          {rowData.healthStatus ?? "--"}
        </span>
      ),
    },

    {
      field: "status",
      header: "Status",
      body: (rowData) =>
        rowData.status !== null ? (
          rowData.status ? (
            <Tag className="custom-success-tag" value="Active" />
          ) : (
            <Tag className="custom-danger-tag" value="In-Active" />
          )
        ) : (
          "--"
        ),
    },
    {
      header: "Action",
      body: actionTemplate,
    },
  ];

  const exportCSV = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(`/Portal/kiosks/get-all`);
      exportToExcel(response.data.body, columnsData, "KioskData");
    } catch (error) {
      toast.error("Failed to export data.");
      console.error("Export Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog
        header={
          <div className="popup-header">
            <div className="popup-header-text">
              {isEdit ? "Edit Kiosk" : "Add New Kiosk"}
            </div>
          </div>
        }
        visible={showDialog}
        onHide={onHide}
        className="dialog-size"
      >
        <EditAddForm
          rowData={rowselect}
          setShowDialog={setShowDialog}
          getKioskData={getKioskData}
          showDialog={showDialog}
          editable={editable}
          onHide={onHide}
          formData={isEdit ? selectedData : null}
          setRes={setRes}
        />
      </Dialog>
      <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header="Kiosk Details"
        className="dialog-size"
      >
        <Details rowData={rowselect} />
      </Dialog>

      <div className="grid align-items-center mb-3 p-2 justify-content-between gap-3">
        <div>
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              className="mbl_view"
              placeholder="Search"
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
            />
          </span>
        </div>
        <div className="grid gap-3">
          <Button
            className="custom-btn export-excel secondary-button"
            label="Export Excel"
            icon="pi pi-window-maximize"
            onClick={exportCSV}
          />
          <Button
            label="Add New"
            icon="pi pi-plus"
            onClick={() => {
              setEditable(false);
              toggleDialogMode(false);
            }}
            className="p-button"
          />
        </div>
      </div>

      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}

      <div className="card card-container">
        <DataTable
          emptyMessage="No record found."
          value={filteredList}
          className="custom-data-table"
          scrollable
          globalFilter={globalFilter}
        >
          {columnsData.map((data, index) => (
            <Column
              key={index}
              field={data.field}
              header={data.header}
              body={data.body}
              frozen={data.frozen}
            />
          ))}
        </DataTable>
        {totalRecords > 0 && (
          <PaginatorComponent
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
}
